"use client";
import { motion } from "framer-motion";
import { FaGem } from "react-icons/fa";
import { useState, useEffect } from "react";

const Loading = () => {
  const [showSpinner, setShowSpinner] = useState(false);
  const [hint, setHint] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSpinner(true);
    }, 300);

    // Set a random hint when the component mounts
    const hints = [
      "Finding rare tasks for you...",
      "Refilling your gem pouch...",
      "Summoning luck 🍀...",
      "Warming up the boosters...",
      "Verifying your adventure path...",
      "Calibrating task rewards...",
      "Sharpening your quests...",
      "Spinning up your lucky streak...",
    ];
    setHint(hints[Math.floor(Math.random() * hints.length)]);

    return () => clearTimeout(timer);
  }, []);

  if (!showSpinner) return null;

  return (
    <div className="fixed inset-0 bg-gradient-to-b from-slate-900 to-slate-800 backdrop-blur-md flex items-center justify-center z-50">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="flex flex-col items-center space-y-6"
      >
        <motion.div
          animate={{
            scale: [1, 1.1, 1],
            y: [0, -8, 0],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            repeatType: "mirror",
            ease: "easeInOut",
          }}
          className="text-fuchsia-500 text-6xl drop-shadow-2xl"
        >
          <FaGem
            animate={{
              scale: [1, 1.1, 1],
              y: [0, -8, 0],
              boxShadow: [
                "0 0 0px #9333ea66",
                "0 0 20px #9333ea99",
                "0 0 0px #9333ea66",
              ],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              repeatType: "mirror",
              ease: "easeInOut",
            }}
          />
        </motion.div>

        <motion.h2
          animate={{
            opacity: [0.7, 1, 0.7],
            letterSpacing: ["0.02em", "0.08em", "0.02em"],
          }}
          transition={{
            duration: 2.5,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          className="text-xl md:text-3xl font-bold tracking-wide text-white text-center px-4"
        >
          Loading your adventure...
        </motion.h2>

        {hint && (
          <p className="text-sm text-fuchsia-300 italic text-center px-4">
            {hint}
          </p>
        )}
      </motion.div>
    </div>
  );
};

export default Loading;
